import React, {useEffect} from "react";
import PropTypes from "prop-types";
import Head from 'next/head';
import LogRocket from 'logrocket';
import AuthCheck from "../services/AuthCheck";
import "../scss/main.scss";
import 'react-toastify/scss/main.scss';

export default function MyApp({ Component, pageProps }) {

    useEffect(() => {
        if(process.env.NEXT_PUBLIC_ENV === "production") {
            LogRocket.init('tixnui/collegify-student', {
                release: '1.0.0',
                dom: {
                    textSanitizer: false,
                    inputSanitizer: true,
                },
                console: {
                    isEnabled: false,
                }
            });
            if(AuthCheck.checkCookie()) {
                const user = AuthCheck.checkAuth();
                LogRocket.identify(user.userId, {
                    name: user.firstName + " " + user.lastName,
                    email: user.email,
                    orgName: user.orgName
                });
            }
        }
        try{
            window.onpopstate = function (e) {
                document.querySelector('body').classList?.remove("modal-open");
                document.querySelector('.modal-backdrop')?.classList.remove("modal-backdrop");
                document.querySelector('body').style = '';
            };
        }
        catch(e){
            console.log(e);
        }
    }, []);

    return (
        <>
            <Head>
                <title>{process.env.NEXT_PUBLIC_APP_NAME} Student Panel</title>
                <meta name="viewport" content="minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no, viewport-fit=cover" />
            </Head>
            <Component {...pageProps} />
        </>
    )
}

MyApp.propTypes = {
    Component: PropTypes.func,
    pageProps: PropTypes.object
}